import { render, staticRenderFns } from "./user_search.vue?vue&type=template&id=b8fa683e&scoped=true&"
import script from "./user_search.vue?vue&type=script&lang=js&"
export * from "./user_search.vue?vue&type=script&lang=js&"
import style0 from "./user_search.vue?vue&type=style&index=0&id=b8fa683e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fa683e",
  null
  
)

export default component.exports